import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HaylieService } from '../../core/services/haylie.service'
import { ePicture } from '../../core/services/entities'

@Component({
  selector: 'app-gallery.component',
  imports: [CommonModule],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
})
export class GalleryComponent {

  model_pics: ePicture[] = [];

  constructor(private haylie: HaylieService) { 
    
  }

  ngAfterViewInit(): void {
    this.get_gallery();
  }
  get_gallery(): void {
    this.haylie.get_gallery().then(this.load_gallery);
  }
  private load_gallery = (p_response: any) =>  {
    var l_response = JSON.parse(p_response);
    this.model_pics = l_response.pictures;
    return this.model_pics;
    
  }

}
